import { Bundle } from "../types/bundles"

export const findBundleById = (bundles: Bundle[], id?: number) => {
  const bundle = bundles.find(bundle => bundle.id === id)
  return bundle
}

export const getBundleTotal = (bundle: Bundle, discount?: number) => {
  const total = bundle.skus.reduce((total, sku) => {
    return sku.value + total
  }, 0)
  
  return total + (discount || 0)
}
